/**
 * Created by calhosh on 5/12/2020
 */

export const API_ERRORS = 'API_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';
export const WARNING_MESSAGE = 'WARNING_MESSAGE';
export const INFO_MESSAGE = 'INFO_MESSAGE';
export const VERSION_UPDATE = 'VERSION_UPDATE';

export const GET_LANGUAGES = 'GET_LANGUAGES';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const CLIENT_VALIDATION_ERROR = 'CLIENT_VALIDATION_ERROR';
export const HIDE_LOADING_INDICATOR = 'HIDE_LOADING_INDICATOR';
export const SHOW_LOADING_INDICATOR = 'SHOW_LOADING_INDICATOR';
export const GET_ENGAGEMENT = 'GET_ENGAGEMENT';
export const GET_ENGAGEMENT_FORM_ACTIONS = 'GET_ENGAGEMENT_FORM_ACTIONS';
export const SET_ENGAGEMENT_ID = 'SET_ENGAGEMENT_ID';
export const SET_IS_ARESVIEW = 'SET_IS_ARESVIEW';
export const SET_SERVER_PRINT_DATA = 'SET_SERVER_PRINT_DATA';
export const SET_IS_DRAWER_MODE = 'SET_IS_DRAWER_MODE';
export const SET_IS_TRACK_CHANGES_VIEW = 'SET_IS_TRACK_CHANGES_VIEW';
export const SET_IS_COMPARE_RESPONSES_VIEW = 'SET_IS_COMPARE_RESPONSES_VIEW';
export const SET_IS_GUIDEDWORKFLOWV2 = 'SET_IS_GUIDEDWORKFLOWV2';
export const SET_HAS_BODY_ID_FILTER = 'SET_HAS_BODY_ID_FILTER';
export const SET_NAVIGATION_FILTER = 'SET_NAVIGATION_FILTER';
export const GET_ENGAGEMENT_TEAM_MEMBERS = 'GET_ENGAGEMENT_TEAM_MEMBERS';
export const LOAD_ENGAGEMENTMETADATA = 'LOAD_ENGAGEMENTMETADATA';
export const GET_ENGAGEMENT_USERS_WITHROLES = 'GET_ENGAGEMENT_USERS_WITHROLES';
export const GET_QUICKLINKS_BY_ENGAGEMENTID = 'GET_QUICKLINKS_BY_ENGAGEMENTID';
export const GET_CONFIGURATIONS = 'GET_CONFIGURATIONS';
export const GET_COUNTRY_STATUS = 'GET_COUNTRY_STATUS';
export const GET_ALL_ENGAGEMENT_USER_ROLES = 'GET_ALL_ENGAGEMENT_USER_ROLES';
export const GET_ALL_RBAC_USER_ROLES = 'GET_ALL_RBAC_USER_ROLES';
export const GET_WORKSPACE_METADATA = 'GET_WORKSPACE_METADATA';
export const GET_BOOKMARK_TASKS = 'GET_BOOKMARK_TASKS';
export const CHECK_USER_ACCEPTED_PAANS_POLICY = 'CHECK_USER_ACCEPTED_PAANS_POLICY';
export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES';
export const GET_CONTENT_UPDATES = 'GET_CONTENT_UPDATES';
export const IMPORT_CONTENT = 'IMPORT_CONTENT';
export const UPDATE_ENGAGEMENT = 'UPDATE_ENGAGEMENT';

/*Workspace Engagement*/
export const GET_WORKSPACE_ENGAGEMENTS = 'GET_WORKSPACE_ENGAGEMENTS';
export const CLEAN_WORKSPACE_ENGAGEMENTS = 'CLEAN_WORKSPACE_ENGAGEMENTS';

/*Forms*/
export const UPDATE_STORYBOOK = 'UPDATE_STORYBOOK';
export const GET_FORM_DATA = 'GET_FORM_DATA';
export const GET_FORM_BODIES_BY_SECTIONID = 'GET_FORM_BODIES_BY_SECTIONID';
export const GET_FORM_BODIES_BY_BODYTYPEID = 'GET_FORM_BODIES_BY_BODYTYPEID';
export const GET_FORM_BODIES_AFTER_RESPONSE = 'GET_FORM_BODIES_AFTER_RESPONSE';
export const UPDATE_RICH_TEXT_BODY = 'UPDATE_RICH_TEXT_BODY';
export const SET_FORM_BODY_SAVE_STATE = 'SET_FORM_BODY_SAVE_STATE';
export const CLEAR_FORM_BODY_SAVE_STATE = 'CLEAR_FORM_BODY_SAVE_STATE';
export const CLEAR_FORM_BODY_SAVE_STATE_BY_BODY_ID = 'CLEAR_FORM_BODY_SAVE_STATE_BY_BODY_ID';
export const UPDATE_FORM_BODY_RESPONSE = 'UPDATE_FORM_BODY_RESPONSE';
export const UPDATE_FORM_BODY_RESPONSE_FOR_UPDATE = 'UPDATE_FORM_BODY_RESPONSE_FOR_UPDATE';
export const DELETE_FORM_BODY = 'DELETE_FORM_BODY';
export const GET_RELATED_OBJECTS = 'GET_RELATED_OBJECTS';
export const DELETE_RELATED_OBJECTS = 'DELETE_RELATED_OBJECTS';
export const CREATE_RELATED_OBJECTS = 'CREATE_RELATED_OBJECTS';
export const DELETE_SECTION_RELATED_OBJECTS = 'DELETE_SECTION_RELATED_OBJECTS';
export const CREATE_SECTION_RELATED_OBJECTS = 'CREATE_SECTION_RELATED_OBJECTS';
export const DELETE_BODY_RELATED_OBJECT = 'DELETE_BODY_RELATED_OBJECT';
export const CREATE_BODY_RELATED_OBJECT = 'CREATE_BODY_RELATED_OBJECT';
export const CREATE_CUSTOM = 'CREATE_CUSTOM';
export const CREATE_DUPLICATE_SECTION = 'CREATE_DUPLICATE_SECTION';
export const DELETE_SECTION = 'DELETE_SECTION';
export const DELETE_CUSTOM_SECTION = 'DELETE_CUSTOM_SECTION';
export const SET_GROUP_AUDIT_DOCUMENT_UPLOAD = 'SET_GROUP_AUDIT_DOCUMENT_UPLOAD';
export const EDIT_SECTION = 'EDIT_SECTION';
export const EDIT_BODY = 'EDIT_BODY';
export const UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE = 'UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE';
export const UPDATE_RELATEOBJECTS_AFTER_RESPONSE = 'UPDATE_RELATEOBJECTS_AFTER_RESPONSE';
export const GET_SECTION_RELATED_OBJECTS = 'GET_SECTION_RELATED_OBJECTS';
export const ADD_CUSTOM_BODY = 'ADD_CUSTOM_BODY';
export const DELETE_HEADER = 'DELETE_HEADER';
export const EDIT_HEADER = 'EDIT_HEADER';
export const UPDATE_SECTION_RELATEDOBJECTS_AFTER_RESPONSE = 'UPDATE_SECTION_RELATEDOBJECTS_AFTER_RESPONSE';
export const UPDATE_FORM_BODY_DISPLAY_DATA = 'UPDATE_FORM_BODY_DISPLAY_DATA';
export const UPDATE_FORM_BODY_RESPONSE_NO_STORE_UPDATE = 'UPDATE_FORM_BODY_RESPONSE_NO_STORE_UPDATE';
export const UPDATE_BODY_FREE_TEXT = 'UPDATE_BODY_FREE_TEXT';
export const UPDATE_BODY_FREE_TEXT_IN_FORM_BODY_DISPLAY_DATA_FOR_UPDATING =
	'UPDATE_BODY_FREE_TEXT_IN_FORM_BODY_DISPLAY_DATA_FOR_UPDATING';
export const UPDATE_BODY_ON_CONFLICT = 'UPDATE_BODY_ON_CONFLICT';

export const CLEAR_FORMBODYDISPLAYDATA = 'CLEAR_FORMBODYDISPLAYDATA';
export const UPDATE_FORM_BODY_DATA = 'UPDATE_FORM_BODY_DATA';
export const UPDATE_FORMBODY_RISKFACTORS = 'UPDATE_FORMBODY_RISKFACTORS';
export const CREATE_RISK_FORMBODYOPTION = 'CREATE_RISK_FORMBODYOPTION';
export const DELETE_RISK_FORMBODYOPTION = 'DELETE_RISK_FORMBODYOPTION';

export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ASSERTIONS_FOR_ACCOUNTID = 'GET_ASSERTIONS_FOR_ACCOUNTID';
export const GET_ASSERTIONS_FOR_ACCOUNTID_SEM = 'GET_ASSERTIONS_FOR_ACCOUNTID_SEM';
export const GET_SCOTS_FOR_ASSERTIONIDS = 'GET_SCOTS_FOR_ASSERTIONIDS';

export const UPDATE_INHERENTRISKTYPE_FOR_ASSERTION = 'UPDATE_INHERENTRISKTYPE_FOR_ASSERTION';
export const UPDATE_RISK_FOR_ASSERTION = 'UPDATE_RISK_FOR_ASSERTION';
export const ADD_INHERENTRISKTYPE_FOR_ASSERTION = 'ADD_INHERENTRISKTYPE_FOR_ASSERTION';
export const DELETE_ASSERTION_FOR_ACCOUNT = 'DELETE_ASSERTION_FOR_ACCOUNT';
export const DELETE_REVIEWS_FOR_ACCOUNTID = 'DELETE_REVIEWS_FOR_ACCOUNTID';
export const GET_ACCOUNTS_EDIT = 'GET_ACCOUNTS_EDIT';
export const ADD_REVIEWS_FOR_ACCOUNTID = 'ADD_REVIEWS_FOR_ACCOUNTID';
export const GET_REVIEWS_FOR_ACCOUNTID = 'GET_REVIEWS_FOR_ACCOUNTID';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';

export const GET_ALL_DOCUMENTS = 'GET_ALL_DOCUMENTS';
export const SET_DOCUMENT_ID = 'SET_DOCUMENT_ID';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const SET_MODAL_LEVEL = 'SET_MODAL_LEVEL';
export const SET_IS_ADC_MODAL_OPEN = 'SET_IS_ADC_MODAL_OPEN';
export const GET_ALL_DOCUMENT_EXTENSION = 'GET_ALL_DOCUMENT_EXTENSION';
export const CREATE_DOCUMENT_EXTENSION_CHANGE_COMMENT = 'CREATE_DOCUMENT_EXTENSION_CHANGE_COMMENT';
export const UPDATE_DOCUMENT_EXTENSION_CHANGE_COMMENT = 'UPDATE_DOCUMENT_EXTENSION_CHANGE_COMMENT';
export const ADD_APPROVAL = 'ADD_APPROVAL';
export const SET_APPROVALS = 'SET_APPROVALS';
export const CREATE_SNAPSHOT = 'CREATE_SNAPSHOT';
export const DELETE_APPROVAL = 'DELETE_APPROVAL';
export const GET_DOCUMENT_SIGN_OFFS = 'GET_DOCUMENT_SIGN_OFFS';
export const GET_DOCUMENT = 'GET_DOCUMENT';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const DELETE_DOCUMENT_BY_ID = 'DELETE_DOCUMENT_BY_ID';
export const CREATE_INDEPENDENCE_FORM = 'CREATE_INDEPENDENCE_FORM';
export const ADD_DUPLICATE_DOCUMENT = 'ADD_DUPLICATE_DOCUMENT';
export const CLEAR_DUPLICATE_DOCUMENTS = 'CLEAR_DUPLICATE_DOCUMENTS';
export const REMOVE_TASK_DOCUMENT = 'REMOVE_TASK_DOCUMENT';
export const DELETE_TASK_DOCUMENT_RELATE = 'DELETE_TASK_DOCUMENT_RELATE';
export const SELECT_DOCUMENT_OVERWRITE = 'SELECT_DOCUMENT_OVERWRITE';
export const PATCH_DOCUMENT = 'PATCH_DOCUMENT';
export const UPDATE_DOCUMENT_METADATA = 'UPDATE_DOCUMENT_METADATA';
export const UNLINK_SHARED_DOCUMENT = 'UNLINK_SHARED_DOCUMENT';

export const GET_ALL_TASKS = 'GET_ALL_TASKS';
export const UPDATE_COMPLETED_TASK = 'UPDATE_COMPLETED_TASK';
export const CLEAR_TASK_LIST = 'CLEAR_TASK_LIST';
export const RESET_TASK_LIST = 'RESET_TASK_LIST';
export const SELECT_ENGAGEMENT_USERROLE_ITEM = 'SELECT_ENGAGEMENT_USERROLE_ITEM';
export const UPDATE_DUE_DATE = 'UPDATE_DUE_DATE';
export const UPDATE_EP_EQR_SIGNOFF_INFO_TASK_LIST = 'UPDATE_EP_EQR_SIGNOFF_INFO_TASK_LIST';

export const GET_ALL_TASKS_OVERVIEW = 'GET_ALL_TASKS_OVERVIEW';
export const GET_ALL_BUILD_TASKS = 'GET_ALL_BUILD_TASKS';
export const GET_ALL_TASKS_COUNT = 'GET_ALL_TASKS_COUNT';
export const GET_ALL_TASKS_FOR_WCGW = 'GET_ALL_TASKS_FOR_WCGW';
export const GET_TASKGROUP_BY_ID = 'GET_TASKGROUP_BY_ID';
export const ADD_RELATED_TASK = 'ADD_RELATED_TASK';

export const GET_ALL_TIMEPHASES = 'GET_ALL_TIMEPHASES';

export const GET_VALIDATIONCOUNTS = 'GET_VALIDATIONCOUNTS';
export const GET_VALIDATIONDETAILS = 'GET_VALIDATIONDETAILS';
export const GET_WITHOUT_APPROVAL_VALIDATION_COUNTS = 'GET_WITHOUT_APPROVAL_VALIDATION_COUNTS';
export const UNLOAD_VALIDATION_COUNTS = 'UNLOAD_VALIDATION_COUNTS';
export const UNLOAD_VALIDATION_DETAILS = 'UNLOAD_VALIDATION_DETAILS';
export const REFRESH_VALIDATION_COUNTS = 'REFRESH_VALIDATION_COUNTS';
export const SET_SHOW_INCOMPLETE = 'SET_SHOW_INCOMPLETE';
export const GET_INCOMPLETE_VALIDATIONS = 'GET_INCOMPLETE_VALIDATIONS';

export const GET_ASSERTIONS_FOR_ENGAGEMENTID = 'GET_ASSERTIONS_FOR_ENGAGEMENTID';
export const SET_RISKID_ASSERTIONID = 'SET_RISKID_ASSERTIONID';
export const GET_ASSERTIONS_FOR_RISKID = 'GET_ASSERTIONS_FOR_RISKID';

export const GET_FORM_PROFILE_DATA_BY_ID = 'GET_FORM_PROFILE_DATA_BY_ID';
export const UPDATE_FORM_PROFILE_RESPONSE = 'UPDATE_FORM_PROFILE_RESPONSE';

export const GET_ALL_RELATED_DOCUMENTS_FOR_BODIES = 'GET_ALL_RELATED_DOCUMENTS_FOR_BODIES';
export const RESET_BODY_RELATED_DOCUMENTS = 'RESET_BODY_RELATED_DOCUMENTS';
export const ADD_UPLOADING_DOCUMENT = 'ADD_UPLOADING_DOCUMENT';
export const GET_RELATED_DOCUMENT_FOR_BODY = 'GET_RELATED_DOCUMENT_FOR_BODY';
export const CHECK_IN_CHECK_OUT_DOCUMENT = 'CHECK_IN_CHECK_OUT_DOCUMENT';

export const SUBMIT_INDEPENDENCE = 'SUBMIT_INDEPENDENCE';
export const SUBMIT_INDEPENDENCE_ACTION = 'SUBMIT_INDEPENDENCE_ACTION';
export const SUBMIT_INDEPENDENCE_TEMPLATE = 'SUBMIT_INDEPENDENCE_TEMPLATE';
export const SUBMIT_PROFILE = 'SUBMIT_PROFILE';
export const CLEAR_PROFILE_DATA = 'CLEAR_PROFILE_DATA';

export const OVERWRITE_FORM = 'OVERWRITE_FORM';

export const POST_LINKED_RESPONSE = 'POST_LINKED_RESPONSE';
export const GET_LINKED_DOCUMENTS = 'GET_LINKED_DOCUMENTS';
export const SET_IS_SHARED = 'SET_IS_SHARED';
export const UPDATE_DOCUMENT_STATUS = 'UPDATE_DOCUMENT_STATUS';
export const SET_UNLINK_INITIATED = 'SET_UNLINK_INITIATED';

/* MANAGE OBJECTS */
export const GET_All_SCOTS = 'GET_All_SCOTS';
export const GET_ALL_ITSOAPPLICATIONS = 'GET_ALL_ITSOAPPLICATIONS';
export const GET_ALL_ITPROCESSES = 'GET_ALL_ITPROCESSES';
export const GET_ALL_ITPROCESSES_WITHOUT_PAGINATION = 'GET_ALL_ITPROCESSES_WITHOUT_PAGINATION';
export const GET_ENGAGEMENT_ALL_SCOTS = 'GET_ALL_ENGAGEMENT_SCOTS';
export const GET_ITPROCESS_BY_ID = 'GET_ITPROCESS_BY_ID';

/* WCGWs */
export const PUT_WCGW_TASK = 'PUT_WCGW_TASK';
export const DELETE_WCGW_TASK = 'DELETE_WCGW_TASK';
export const PUT_WCGW = 'PUT_WCGW';
export const GET_WCGWS = 'GET_WCGWS';

export const GET_RISKS = 'GET_RISKS';
export const GET_RISK_BY_ID = 'GET_RISK_BY_ID';
export const CLEAR_RISK = 'CLEAR_RISK';
export const GET_RISKS_FOR_WCGWID = 'GET_RISKS_FOR_WCGWID';
export const GET_RELATED_RISKS_FOR_WCGWID = 'GET_RELATED_RISKS_FOR_WCGWID';
export const GET_RISK_TYPES = 'GET_RISK_TYPES';
export const GET_RISKS_BY_TYPE = 'GET_RISKS_BY_TYPE';
export const RELATE_SCOT_TO_RISK = 'RELATE_SCOT_TO_RISK';
export const UNRELATE_SCOT_TO_RISK = 'UNRELATE_SCOT_TO_RISK';
export const UPDATE_STORE_RELATE_SCOT_TO_RISK = 'UPDATE_STORE_RELATE_SCOT_TO_RISK';
export const UPDATE_STORE_UNRELATE_SCOT_TO_RISK = 'UPDATE_STORE_UNRELATE_SCOT_TO_RISK';
export const UPDATE_STORE_UNRELATE_ACCOUNT_TO_RISK = 'UPDATE_STORE_UNRELATE_ACCOUNT_TO_RISK';

export const SAVE_RISK_WCGW_SELECTION = 'SAVE_RISK_WCGW_SELECTION';
export const SET_RISK_WCGW_SELECTED = 'SET_RISK_WCGW_SELECTED';

export const GET_RELATED_WCGWS = 'GET_RELATED_WCGWS';
export const GET_RISKS_TO_RELATE = 'GET_RISKS_TO_RELATE';

/* DETAILS */
export const GET_ALL_RELATED_DOCUMENTS = 'GET_ALL_RELATED_DOCUMENTS';
export const GET_ALL_RELATED_DOCUMENTS_FOR_SAMPLE = 'GET_ALL_RELATED_DOCUMENTS_FOR_SAMPLE';
export const CREATE_RELATED_DOCUMENT = 'CREATE_RELATED_DOCUMENT';
export const UPDATE_DOCUMENT_COUNT_ON_TEMPORARY_FILE_UPLOAD = 'UPDATE_DOCUMENT_COUNT_ON_TEMPORARY_FILE_UPLOAD';
export const DELETE_RELATED_DOCUMENT = 'DELETE_RELATED_DOCUMENT';

/*USER*/
export const GET_USER_BY_GUI = 'GET_USER_BY_GUI';

/*User Search*/
export const GET_USER_SEARCH = 'GET_USER_SEARCH';

/*User Search*/
export const GET_USER_SEARCH_GA = 'GET_USER_SEARCH_GA';

/*Internal Users*/
export const GET_INTERNAL_USERS = 'GET_INTERNAL_USERS';
export const PATCH_DEACTIVATE_USERS_LIST = 'PATCH_DEACTIVATE_USERS_LIST';
export const POST_INTERNAL_USER = 'POST_INTERNAL_USER';

/* User Presence */
export const GET_USER_PRESENCE = 'GET_USER_PRESENCE';
export const RESET_USER_PRESENCE = 'RESET_USER_PRESENCE';
export const DELETE_USER_PRESENCE = 'DELETE_USER_PRESENCE';
export const GET_INTERNAL_USER_BY_ID = 'GET_INTERNAL_USER_BY_ID';

/* Engagement Comments */
export const GET_ALL_ENGAGEMENT_COMMENTS = 'GET_ALL_ENGAGEMENT_COMMENTS';
export const CREATE_ENGAGEMENT_COMMENT = 'CREATE_ENGAGEMENT_COMMENT';
export const CREATE_ENGAGEMENT_COMMENT_REPLY = 'CREATE_ENGAGEMENT_COMMENT_REPLY';
export const UPDATE_ENGAGEMENT_COMMENT = 'UPDATE_ENGAGEMENT_COMMENT';
export const UPDATE_ENGAGEMENT_COMMENT_STATUS = 'UPDATE_ENGAGEMENT_COMMENT_STATUS';
export const SET_ENGAGEMENT_COMMENTS_CONFIG_DATA = 'SET_ENGAGEMENT_COMMENTS_CONFIG_DATA';
export const CLEAR_ENGAGEMENT_COMMENTS = 'CLEAR_ENGAGEMENT_COMMENTS';
export const SET_SELECTED_ENGAGEMENT_COMMENT_GUID = 'SET_SELECTED_ENGAGEMENT_COMMENT_GUID';
export const DELETE_ENGAGEMENT_COMMENT_PARENT = 'DELETE_ENGAGEMENT_COMMENT_PARENT';
export const DELETE_ENGAGEMENT_COMMENT_CHILD = 'DELETE_ENGAGEMENT_COMMENT_CHILD';
export const SET_ENGAGEMENT_COMMENTS_FILTER = 'SET_ENGAGEMENT_COMMENTS_FILTER';
export const REMOVE_ENGAGEMENT_COMMENTS_FILTER = 'REMOVE_ENGAGEMENT_COMMENTS_FILTER';
export const CLEAR_COMMENTS = 'CLEAR_COMMENTS';
export const UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS = 'UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS';
export const UPDATE_BODY_COMMENT_COUNT_AFTER_CLOSING_COMMENTS = 'UPDATE_BODY_COMMENT_COUNT_AFTER_CLOSING_COMMENTS';
export const UPDATE_BODY_RELATED_COUNT = 'UPDATE_BODY_RELATED_COUNT';
export const GET_FORM_USERS = 'GET_FORM_USERS';
export const DISPLAY_ENGAGEMENT_COMMENT_INPUT_MODAL = 'DISPLAY_ENGAGEMENT_COMMENT_INPUT_MODAL';
export const ADD_TO_ENGAGEMENT_COMMENT_SLICE = 'ADD_TO_ENGAGEMENT_COMMENT_SLICE';

//------------ File Upload constants:Start ----------------
export const SEND_FILES_TO_DOCHELPER = 'SEND_FILES_TO_DOCHELPER';
export const CHECK_IF_DOCHELPER_ONLINE = 'CHECK_IF_DOCHELPER_ONLINE';
export const KRONOS_DOCHELPER_DOWNLOAD_DOCUMENT = 'KRONOS_DOCHELPER_DOWNLOAD_DOCUMENT';
export const KRONOS_DOCHELPER_UPLOAD_DOCUMENT = 'KRONOS_DOCHELPER_UPLOAD_DOCUMENT';
export const KRONOS_DOCHELPER_UPLOAD_COMPLETE = 'KRONOS_DOCHELPER_UPLOAD_COMPLETE';
export const KRONOS_DOCUMENT_UPLOAD_PROGRESS = 'KRONOS_DOCUMENT_UPLOAD_PROGRESS';
export const SET_CHANGE_REASON_REQUIRED = 'SET_CHANGE_REASON_REQUIRED';
export const SHOW_CHANGE_REASON_MODAL = 'SHOW_CHANGE_REASON_MODAL';
export const RESTORE_DOCUMENT_VERSION = 'RESTORE_DOCUMENT_VERSION';
//------------ File Upload constants:End ----------------

/* Review Notes */
export const GET_REVIEW_NOTES = 'GET_REVIEW_NOTES';
export const ADD_NOTE = 'ADD_NOTE';
export const DELETE_NOTE = 'DELETE_NOTE';
export const UPDATE_NOTE_DETAIL = 'UPDATE_NOTE_DETAIL';
export const UPDATE_NOTE_INFO = 'UPDATE_NOTE_INFO';
export const POST_NOTE_REPLY = 'POST_NOTE_REPLY';
export const DELETE_NOTE_DETAIL = 'DELETE_NOTE_DETAIL';
export const EXPAND_COLLAPSE_NOTE = 'EXPAND_COLLAPSE_NOTE';
export const CLEAR_REVIEW_NOTES = 'CLEAR_REVIEW_NOTES';

/* Media Playing */
export const SET_IS_MEDIA_PLAYING = 'SET_IS_MEDIA_PLAYING';

/* Snapshot */
export const GET_SNAPSHOT_BY_ID = 'GET_SNAPSHOT_BY_ID';
export const GET_SNAPSHOT_COMPARE_BY_ID = 'GET_SNAPSHOT_COMPARE_BY_ID';
export const GET_SNAPSHOTS = 'GET_SNAPSHOTS';
export const CLEAR_RIGHT_SIDE_SNAPSHOT_VIEW = 'CLEAR_RIGHT_SIDE_SNAPSHOT_VIEW';
export const SHOW_HIDE_RIGHT_SIDE_SNAPSHOT_VIEW = 'SHOW_HIDE_RIGHT_SIDE_SNAPSHOT_VIEW';
export const SHOW_HIDE_LEFT_SIDE_SNAPSHOT_VIEW = 'SHOW_HIDE_LEFT_SIDE_SNAPSHOT_VIEW';
export const CLEAR_SNAPSHOT_COMPARE_VIEW = 'CLEAR_SNAPSHOT_COMPARE_VIEW';

export const GET_ALL_SCOTS = 'scots/getAll';
export const GET_SCOT_BY_ID = 'GET_SCOT_BY_ID';
export const CREATE_SCOT = 'CREATE_SCOT';
export const UPDATE_SCOT = 'UPDATE_SCOT';
export const DELETE_SCOT = 'DELETE_SCOT';
export const GET_SCOTS_BY_ENG = 'GET_SCOTS_BY_ENG';
export const POST_SCOT_JOURNAL_SOURCE = 'POST_SCOT_JOURNAL_SOURCE';
export const DELETE_SCOT_JOURNAL_SOURCE = 'DELETE_SCOT_JOURNAL_SOURCE';
export const CLEAN_SCOT = 'CLEAN_SCOT';

export const GET_CONTROL_BY_ID = 'GET_CONTROL_BY_ID';
export const UPDATE_CONTROL = 'UPDATE_CONTROL';
export const GET_ALL_CONTROLS = 'GET_ALL_CONTROLS';

export const GET_ENGAGEMENT_ALL_ITCONTROLS = 'GET_ENGAGEMENT_ALL_ITCONTROLS';
export const GET_ALL_ITCONTROLS = 'GET_ALL_ITCONTROLS';
export const GET_ITCONTROL_BY_ID = 'GET_ITCONTROL_BY_ID';
export const UPDATE_ITCONTROL = 'UPDATE_ITCONTROL';
export const CREATE_ITCONTROL = 'CREATE_ITCONTROL';
export const DELETE_ITCONTROL = 'DELETE_ITCONTROL';
export const REFRESH_UNRELATED_ITCONTROLS = 'REFRESH_UNRELATED_ITCONTROLS';

/* Print view */
export const SET_IS_STANDALONE_VIEW = 'SET_IS_STANDALONE_VIEW';
export const SET_DOCUMENT_LAST_MODIFIED_DATE = 'SET_DOCUMENT_LAST_MODIFIED_DATE';
export const UPDATE_DOCUMENT_LAST_MODIFIED_DATE = 'UPDATE_DOCUMENT_LAST_MODIFIED_DATE';

/*ITProcess*/
export const CREATE_ITPROCESS = 'CREATE_ITPROCESS';
export const UPDATE_ITPROCESS = 'UPDATE_ITPROCESS';
export const DELETE_ITPROCESS = 'itProcesses/byId/delete';
export const IT_PROCESS_SELECTED = 'itProcesses/selected';
export const RELATE_TASK_ITPROCESS = 'RELATE_TASK_ITPROCESS';
export const UNRELATE_TASK_ITPROCESS = 'UNRELATE_TASK_ITPROCESS';

/*ITApplication*/
export const UPDATE_ITAPPLICATION = 'UPDATE_ITAPPLICATION';
export const GET_IT_APPLICATION = 'GET_IT_APPLICATION';
export const GET_ALL_IT_APPLICATIONS = 'itApplications/getAll';
export const IT_APPLICATION_SELECTED = 'itApplication/selected';
export const CREATE_ITAPPLICATION_SO = 'CREATE_ITAPPLICATION_SO';
export const DELETE_ITAPPLICATION = 'itApplications/byId/delete';
export const GET_ITAPPSO_BY_ID = 'GET_ITAPPSO_BY_ID';
export const CREATE_ITAPPLICATION_ITPROCESS_RELATIONSHIP = 'itApplication/itProcess/create';
export const DELETE_ITAPPLICATION_ITPROCESS_RELATION = 'itApplication/itProcess/delete';

/*ITRisk*/
export const UPDATE_ITRISK = 'UPDATE_ITRISK';
export const CREATE_ITRISK = 'CREATE_ITRISK';
export const RELATE_ITRISK_ITCONTROL = 'RELATE_ITRISK_ITCONTROL';
export const UNRELATE_ITRISK_ITCONTROL = 'UNRELATE_ITRISK_ITCONTROL';
export const DELETE_ITRISK = 'DELETE_ITRISK';

/*Risk*/
export const UPDATE_RISK = 'UPDATE_RISK';
export const MANAGE_RISK = 'MANAGE_RISK';
export const CREATE_RISK = 'CREATE_RISK';
export const CLEAR_NEW_RISK = 'CLEAR_NEW_RISK';
export const CREATE_ASSERTION_RISK_RELATION = 'CREATE_ASSERTION_RISK_RELATION';
export const DELETE_ASSERTION_RISK_RELATION = 'DELETE_ASSERTION_RISK_RELATION';
export const UPDATE_ASSERTION_RISK_RELATION = 'UPDATE_ASSERTION_RISK_RELATION';
export const DELETE_RISK = 'DELETE_RISK';
export const DISPLAY_ESTIMATETYPE_MISMATCH_CLIENT_VALIDATION_MESSAGE =
	'DISPLAY_ESTIMATETYPE_MISMATCH_CLIENT_VALIDATION_MESSAGE';

/*Task*/
export const CREATE_TASK = 'CREATE_TASK';
export const CHANGE_TASK_ASSIGNMENT_STATUS = 'CHANGE_TASK_ASSIGNMENT_STATUS';
export const CHANGE_TASK_STATUS = 'CHANGE_TASK_STATUS';
export const GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY = 'GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY';
export const GET_TASK_DOCUMENTS = 'GET_TASK_DOCUMENTS';
export const UPDATE_DOCUMENT_ON_ADDING_SIGNOFF = 'UPDATE_DOCUMENT_ON_ADDING_SIGNOFF';
export const UPDATE_DOCUMENT_ON_SIGNOFF_REMOVAL = 'UPDATE_DOCUMENT_ON_SIGNOFF_REMOVAL';

/* Filters */
export const SET_FILTERS = 'SET_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const GET_FILTER_ENTITIES = 'GET_FILTER_ENTITIES';
export const SET_FILTER = 'SET_FILTER';

/*Sample*/
export const GET_ALL_SAMPLE_LIST = 'GET_ALL_SAMPLE_LIST';
export const CREATE_SAMPLE_LIST = 'CREATE_SAMPLE_LIST';
export const UPDATE_SAMPLE_LIST = 'UPDATE_SAMPLE_LIST';
export const GET_SAMPLEITEMS_BY_ID = 'GET_SAMPLEITEMS_BY_ID';
export const CREATE_SAMPLE = 'CREATE_SAMPLE';
export const GET_SAMPLE_ITEMS = 'GET_SAMPLE_ITEMS';
export const EDIT_SAMPLE_ITEM = 'EDIT_SAMPLE_ITEM';
export const DELETE_SAMPLE_ITEM = 'DELETE_SAMPLE_ITEM';
export const CLEAR_SAMPLE_ATTRIBUTES = 'CLEAR_SAMPLE_ATTRIBUTES';
export const ADD_SAMPLE_ATTRIBUTES_STATUS = 'ADD_SAMPLE_ATTRIBUTES_STATUS';
export const GET_SAMPLE_ITEM_TAGS = 'GET_SAMPLE_ITEM_TAGS';
export const GET_SAMPLE_ITEM_TAG_GROUPS = 'GET_SAMPLE_ITEM_TAG_GROUPS';
export const DELETE_DOCUMENT_FROM_SAMPLE_ITEM = 'DELETE_DOCUMENT_FROM_SAMPLE_ITEM';
export const CLEAR_SAMPLE_RELATED_DOCUMENTS = 'CLEAR_SAMPLE_RELATED_DOCUMENTS';
export const DELETE_ATTRIBUTE_FROM_SAMPLE_ITEM = 'DELETE_ATTRIBUTE_FROM_SAMPLE_ITEM';
export const RELATE_TAG_SAMPLE_ITEM = 'RELATE_TAG_SAMPLE_ITEM';
export const UNRELATE_TAG_SAMPLE_ITEM = 'UNRELATE_TAG_SAMPLE_ITEM';
export const RELATE_SAMPLE_ITEM_DOCUMENT = 'RELATE_SAMPLE_ITEM_DOCUMENT';
export const UPDATE_SAMPLE_ATTRIBUTES_STATUS = 'UPDATE_SAMPLE_ATTRIBUTES_STATUS';
export const CREATE_TAG_GROUP = 'CREATE_TAG_GROUP';
export const CREATE_TAG = 'CREATE_TAG';
export const DELETE_SAMPLE_TAG = 'DELETE_SAMPLE_TAG';
export const EDIT_SAMPLE_TAG = 'EDIT_SAMPLE_TAG';
export const UPDATE_TAG_GROUP = 'UPDATE_TAG_GROUP';
export const GET_TAG_GROUP_ID = 'GET_TAG_GROUP_ID';
export const DELETE_SAMPLE_TAG_GROUP = 'DELETE_SAMPLE_TAG_GROUP';

/*Ares*/
//TaskGroup
export const GET_ALL_TASKS_BY_GROUP_ID = 'GET_ALL_TASKS_BY_GROUP_ID';
export const ARES_GET_TASK_BY_ID = 'ARES_GET_TASK_BY_ID';
export const ARES_GET_DOCUMENT_BY_ID = 'ARES_GET_DOCUMENT_BY_ID';
export const ARES_UPDATE_TASK_DOCUMENT_ON_SIGN_OFF = 'ARES_UPDATE_TASK_DOCUMENT_ON_SIGN_OFF';
export const ARES_UPDATE_TASK_DOCUMENT_ON_SIGN_OFF_REMOVAL = 'ARES_UPDATE_TASK_DOCUMENT_ON_SIGN_OFF_REMOVAL';
export const ARES_UPDATE_TASK_DOCUMENT_ON_CONFIRM_CHANGE_REASON = 'ARES_UPDATE_TASK_DOCUMENT_ON_CONFIRM_CHANGE_REASON';
export const ARES_SET_SELECTED_HEADER = 'ARES_SET_SELECTED_HEADER';
export const ARES_CLEAR_FORM_HEADERS = 'ARES_CLEAR_FORM_HEADERS';
export const ARES_REMOVE_SIGN_OFF = 'ARES_REMOVE_SIGN_OFF';

//Risk Factors
export const GET_RISKS_FACTORS = 'GET_RISKS_FACTORS';
export const SET_MY_RISK_FACTOR_DESCRIPTIONS = 'SET_MY_RISK_FACTOR_DESCRIPTIONS';
export const UPDATE_RISK_FACTOR_RELATION = 'UPDATE_RISK_FACTOR_RELATION';
export const UPDATE_RISK_FACTOR_RELATION_DESCRIPTION = 'UPDATE_RISK_FACTOR_RELATION_DESCRIPTION';
export const CREATE_RISK_FACTOR_RELATION = 'CREATE_RISK_FACTOR_RELATION';
export const RELATE_RISK_FACTOR_TO_DESCRIPTION = 'RELATE_RISK_FACTOR_TO_DESCRIPTION';
export const UNRELATE_RISK_FACTOR_FROM_DESCRIPTION = 'UNRELATE_RISK_FACTOR_FROM_DESCRIPTION';
export const EDIT_RISK_FACTOR_DESCRIPTION = 'EDIT_RISK_FACTOR_DESCRIPTION';
export const REMOVE_RISK_FACTOR_RELATION = 'REMOVE_RISK_FACTOR_RELATION';

// Capture annotation
export const ADD_CAPTURE_IMAGE = 'ADD_CAPTURE_IMAGE';
export const SET_CAPTURE_ANNOTATIONS = 'SET_CAPTURE_ANNOTATIONS';
export const REQUEST_CAPTURE_IMAGE_METADATA = 'REQUEST_CAPTURE_IMAGE_METADATA';
export const UPLOAD_CAPTURE_IMAGE = 'UPLOAD_CAPTURE_IMAGE';
export const COMPLETE_CAPTURE_IMAGE_UPLOAD = 'COMPLETE_CAPTURE_IMAGE_UPLOAD';
export const ADD_CAPTURE_ANNOTATION = 'ADD_CAPTURE_ANNOTATION';
export const ENABLE_CAPTURE_ANNOTATION_BOX = 'ENABLE_CAPTURE_ANNOTATION_BOX';
export const SET_CAPTURE_ANNOTATION_BOX = 'SET_CAPTURE_ANNOTATION_BOX';
export const NEW_ANNOTATION_SAVE = 'NEW_ANNOTATION_SAVE';
export const SET_NEW_ANNOTATION_BOUNDING_BOX = 'SET_NEW_ANNOTATION_BOUNDING_BOX';
export const REMOVE_NEW_ANNOTATION = 'REMOVE_NEW_ANNOTATION';
export const GET_CAPTURE_ANNOTATIONS = 'GET_CAPTURE_ANNOTATIONS';
export const SET_ACTIVE_ANNOTATION = 'SET_ACTIVE_ANNOTATION';
export const UNSET_ACTIVE_ANNOTATION = 'UNSET_ACTIVE_ANNOTATION';
export const SET_ANNOTATION_MODE = 'SET_ANNOTATION_MODE';
export const SET_REFERENCE_NUMBER_NEW_ANNOTATION = 'SET_REFERENCE_NUMBER_NEW_ANNOTATION';
export const EDIT_ANNOTATION = 'EDIT_ANNOTATION';
export const DELETE_ANNOTATION = 'DELETE_ANNOTATION';
export const DELETE_DOCUMENT_SCREENSHOT = 'DELETE_DOCUMENT_SCREENSHOT';
export const EDIT_BOUNDINGBOX = 'EDIT_BOUNDINGBOX';
export const ADD_BOUNDINGBOX_ANNOTATION = 'ADD_BOUNDINGBOX_ANNOTATION';
export const CANCEL_BOUNDING_BOX = 'CANCEL_BOUNDING_BOX';
export const SET_CAPTURE_ERROR = 'SET_CAPTURE_ERROR';

//Edit Account
export const GET_ACCOUNT_BY_ID = 'GET_ACCOUNT_BY_ID';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const CLEAN_ACCOUNT = 'CLEAN_ACCOUNT';
export const SAVE_SENT_ASSOCIATED_HELIX_ACCOUNTS = 'SAVE_SENT_ASSOCIATED_HELIX_ACCOUNTS';
export const SAVE_BATCH_HELIX_CANVAS_ACCOUNT_RELATIONS = 'SAVE_BATCH_HELIX_CANVAS_ACCOUNT_RELATIONS';
export const GET_IS_HELIX_CANVAS_ACCOUNT_MAPPINGS_SUCCESSFULL = 'GET_IS_HELIX_CANVAS_ACCOUNT_MAPPINGS_SUCCESSFULL';
export const RELATE_ENTITY_ACCOUNT = 'RELATE_ENTITY_ACCOUNT';
export const UNRELATE_ENTITY_ACCOUNT = 'UNRELATE_ENTITY_ACCOUNT';
export const UPDATE_STORE_ACCOUNT_ASSERTION = 'UPDATE_STORE_ACCOUNT_ASSERTION';

//PSP Indexes
export const GET_AVAILABLE_PSP_INDEXES = 'GET_AVAILABLE_PSP_INDEXES';

//Simple Helix (FormBody)
export const GET_ALL_SIMPLE_HELIX_DOCUMENTS = 'GET_ALL_SIMPLE_HELIX_DOCUMENTS';
export const GET_ALL_SIMPLE_HELIX_NOTES = 'GET_ALL_SIMPLE_HELIX_NOTES';
export const GET_SIMPLE_HELIX_DOCUMENT_BLOB = 'GET_SIMPLE_HELIX_DOCUMENT_BLOB';
export const CLEAR_UPLOADED_SCREENSHOT_DOCUMENT_ID = 'CLEAR_UPLOADED_SCREENSHOT_DOCUMENT_ID';
export const SET_SIMPLE_HELIX_LOADING_STATE = 'SET_SIMPLE_HELIX_LOADING_STATE';
export const SIMPLE_HELIX_BOUNDING_BOXES_SHOW = 'SIMPLE_HELIX_BOUNDING_BOXES_SHOW';
//Helix
export const GET_AVAILABLE_PROJECT_FROM_CANAVS_ENGAGEMENT = 'GET_AVAILABLE_PROJECT_FROM_CANAVS_ENGAGEMENT';
export const GET_PROJECTDETAIL_BY_PROJECTID_FROM_HELIX = 'GET_PROJECTDETAIL_BY_PROJECTID_FROM_HELIX';
export const GET_PROJECT_FILTERMETADATA_BY_PROJECTID_FROM_HELIX = 'GET_PROJECT_FILTERMETADATA_BY_PROJECTID_FROM_HELIX';
export const IS_VALID_USER_WITH_PROJECT_AVAILABLE = 'IS_VALID_USER_WITH_PROJECT_AVAILABLE';
export const CLEANUP_VALID_USER_WITH_PROJECT_AVAILABLE_STATE = 'CLEANUP_VALID_USER_WITH_PROJECT_AVAILABLE_STATE';
export const UPDATE_HELIX_PROJECT = 'UPDATE_HELIX_PROJECT';
export const IMPORT_HELIX_PROJECT = 'IMPORT_HELIX_PROJECT';
export const DELETE_IMPORT_HELIX_PROJECT = 'DELETE_IMPORT_HELIX_PROJECT';
export const GET_HELIX_PROJECT = 'GET_HELIX_PROJECT';
export const CLEANUP_HELIX_PROJECT_STATE = 'CLEANUP_HELIX_PROJECT_STATE';
export const CLEANUP_ENGAGEMENT_HELIX_PROJECTS_STATE = 'CLEANUP_ENGAGEMENT_HELIX_PROJECTS_STATE';

// Materiality
export const GET_MATERIALITY = 'GET_MATERIALITY';
export const UPDATE_MATERIALITY = 'UPDATE_MATERIALITY';
export const CREATE_MATERIALITY = 'CREATE_MATERIALITY';
export const UPDATE_MATERIALITY_ADJUSTED_BASIS = 'UPDATE_MATERIALITY_ADJUSTED_BASIS';
export const ADD_CURRENT_MATERIALITY = 'ADD_CURRENT_MATERIALITY';
export const UPDATE_MATERIALITY_STATE_BY_ID = 'UPDATE_MATERIALITY_STATE_BY_ID';

// Limited Risk Document List
export const GET_LIMITED_RISK_DOCUMENTS = 'GET_LIMITED_RISK_DOCUMENTS';
export const SET_LIMITED_RISK_DOCUMENT_NAME = 'SET_LIMITED_RISK_DOCUMENT_NAME';
export const ADD_LIMITED_RISK_DOCUMENT_SIGNOFF = 'ADD_LIMITED_RISK_DOCUMENT_SIGNOFF';
export const REMOVE_LIMITED_RISK_DOCUMENT_SIGNOFF = 'REMOVE_LIMITED_RISK_DOCUMENT_SIGNOFF';

// Entity Documents
export const GET_ENTITY_DOCUMENTS = 'GET_ENTITY_DOCUMENTS';
export const SET_ENTITY_DOCUMENT_NAME = 'SET_ENTITY_DOCUMENT_NAME';
export const CLEAR_ENTITY_DOCUMENTS = 'CLEAR_ENTITY_DOCUMENTS';
export const ADD_ENTITY_DOCUMENT_SIGNOFF = 'ADD_ENTITY_DOCUMENT_SIGNOFF';
export const REMOVE_ENTITY_DOCUMENT_SIGNOFF = 'REMOVE_ENTITY_DOCUMENT_SIGNOFF';

// Assess Risk Summary
export const GET_ALL_ASSOCIATED_RISKS_SUMMARY = 'GET_ALL_ASSOCIATED_RISKS_SUMMARY';

//Relate Documents
export const ASSOCIATE_TASK_DOCUMENTS = 'ASSOCIATE_TASK_DOCUMENTS';
export const DOCHELPER_ERROR = 'DOCHELPER_ERROR';
export const CREATE_DOCUMENT_COPY = 'CREATE_DOCUMENT_COPY';
export const INVALID_RELATED_ENTITY = 'INVALID_RELATED_ENTITY';

// Forms
export const POST_FORM = 'POST_FORM';
export const IS_LOADING = 'IS_LOADING';

export const BODIES_SPECIAL_CLIENTSIDE_FILTERS = 'BODIES_SPECIAL_CLIENTSIDE_FILTERS';

export const RESET_SCOTS_WITHOUTPAGINATION = 'RESET_SCOTS_WITHOUTPAGINATION';

// Notes Modal actions
export const GET_RNH_NOTE_DETAIL = 'GET_RNH_NOTE_DETAIL';
export const GET_RNH_NOTE_REPLIES = 'GET_RNH_NOTE_REPLIES';
export const POST_RNH_NEW_NOTE = 'POST_RNH_NEW_NOTE';
export const POST_RNH_NOTE_REPLY = 'POST_RNH_NOTE_REPLY';
export const CLEAR_RNH_NOTE_DETAIL = 'CLEAR_RNH_NOTE_DETAIL';
export const OPEN_RNH_NOTE_DETAIL_MODAL = 'OPEN_RNH_NOTE_DETAIL_MODAL';
export const UPDATE_RNH_NOTE_INFO = 'UPDATE_RNH_NOTE_INFO';
export const UPDATE_RNH_NOTE_DETAIL = 'UPDATE_RNH_NOTE_DETAIL';
export const DELETE_RNH_NOTE_DETAIL = 'DELETE_RNH_NOTE_DETAIL';
export const DELETE_RNH_PARENT_NOTE = 'DELETE_RNH_PARENT_NOTE';
export const UPDATE_NOTES_COUNT = 'UPDATE_NOTES_COUNT';
export const GET_FORM_BODY_COMMENT = 'GET_FORM_BODY_COMMENT';

//Handoff
export const HANDOFF_TASK = 'HANDOFF_TASK';
export const GET_TASK_ASSIGNMENTS = 'GET_TASK_ASSIGNMENTS';

export const UPDATE_FORM_DATA_AFTER_BODY_RESPONSE = 'UPDATE_FORM_DATA_AFTER_BODY_RESPONSE';

// Journal entry source
export const GET_JOURNAL_SOURCE = 'GET_JOURNAL_SOURCE';
export const UPDATE_JOURNAL_SOURCE = 'UPDATE_JOURNAL_SOURCE';
export const UPDATE_JOURNAL_SOURCE_RELATED_SCOT = 'UPDATE_JOURNAL_SOURCE_RELATED_SCOT';
export const UPDATE_JOURNAL_SOURCE_CUSTOM_NAME = 'UPDATE_JOURNAL_SOURCE_CUSTOM_NAME';

//Trial balance
export const GET_TRIAL_BALANCE = 'GET_TRIAL_BALANCE';
export const GET_TRIAL_BALANCE_BY_ID = 'GET_TRIAL_BALANCE_BY_ID';

//Annotation
export const OPEN_ANNOTATION_MODAL = 'OPEN_ANNOTATION_MODAL';
export const CLEAR_ANNOTATION_MODAL = 'CLEAR_ANNOTATION_MODAL';
export const UPDATE_ENTITY_ANNOTATION = 'UPDATE_ENTITY_ANNOTATION';
export const DELETE_ENTITY_ANNOTATION = 'DELETE_ENTITY_ANNOTATION';
export const CREATE_ENTITY_ANNOTATION = 'CREATE_ENTITY_ANNOTATION';

//Estimates
export const GET_ESTIMATES = 'GET_ESTIMATES';
export const GET_ESTIMATE_BY_ID = 'GET_ESTIMATE_BY_ID';
export const DELETE_ESTIMATE_DOCUMENT_BY_ID = 'DELETE_ESTIMATE_DOCUMENT_BY_ID';

//Group Audit
export const GET_ALL_ACCOUNTS = 'GET_ALL_ACCOUNTS';
export const SET_ACCOUNTS_PARAMETERS = 'SET_ACCOUNTS_PARAMETERS';
export const POST_GACOMPONENT_ACCOUNT = 'POST_GACOMPONENT_ACCOUNT';
export const DELETE_GACOMPONENT_ACCOUNT = 'DELETE_GACOMPONENT_ACCOUNT';
export const GET_ALL_COMPONENTS = 'GET_ALL_COMPONENTS';
export const GET_ALL_SCOPES = 'GET_ALL_SCOPES';
export const POST_NEW_COMPONENT = 'POST_NEW_COMPONENT';
export const PUT_COMPONENT = 'PUT_COMPONENT';
export const SEND_LINK_REQUEST = 'SEND_LINK_REQUEST';
export const GET_INSTRUCTIONS = 'GET_INSTRUCTIONS';
export const POST_INSTRUCTIONS = 'POST_INSTRUCTIONS';
export const UPDATE_INSTRUCTIONS = 'UPDATE_INSTRUCTIONS';
export const DELETE_INSTRUCTION = 'DELETE_INSTRUCTION';
export const POST_NEW_SECTION = 'POST_NEW_SECTION';
export const PATCH_SECTIONS = 'PATCH_SECTIONS';
export const GET_ASSIGNED_SCOPES = 'GET_ASSIGNED_SCOPES';
export const DELETE_COMPONENT = 'DELETE_COMPONENT';
export const GET_GROUP_SNAPSHOT_BY_ID = 'GET_GROUP_SNAPSHOT_BY_ID';
export const CLEAN_GROUP_SNAPSHOT = 'CLEAN_GROUP_SNAPSHOT';
export const GET_ALL_SNAPSHOTS = 'GET_ALL_SNAPSHOTS';
export const POST_SNAPSHOTS = 'POST_SNAPSHOTS';
export const POST_SEND_INSTRUCTIONS = 'POST_SEND_INSTRUCTIONS';
export const POST_ALRA_PACKAGE = 'POST_ALRA_PACKAGE';
export const CLEAN_COMPONENTS_AND_FORMACTIONS = 'CLEAN_COMPONENTS_AND_FORMACTIONS';
export const POST_INVOLVEMENT_PACKAGE = 'POST_INVOLVEMENT_PACKAGE';
export const POST_SUB_SCOPE = 'POST_SUB_SCOPE';
export const PATCH_SUB_SCOPE = 'PATCH_SUB_SCOPE';
export const DELETE_SUB_SCOPE = 'DELETE_SUB_SCOPE';

// FIT Navigation Panel
export const SET_LEFT_NAVIGATION_ACTIVE_PANEL = 'SET_LEFT_NAVIGATION_ACTIVE_PANEL';

//ST Entities
export const SET_SELECTED_STENTITY_ID = 'SET_SELECTED_STENTITY_ID';
export const CLEAR_SELECTED_STENTITY_ID = 'CLEAR_SELECTED_STENTITY_ID';
export const GET_STENTITY_BY_ID = 'GET_STENTITY_BY_ID';
export const GET_MULTI_ENTITY_BY_ID = 'GET_MULTI_ENTITY_BY_ID';
export const GET_ALL_MULTI_ENTITY = 'GET_ALL_MULTI_ENTITY';
export const DELETE_MULTI_ENTITY = 'DELETE_MULTI_ENTITY';
export const CREATE_STENTITY = 'CREATE_STENTITY';
export const UPDATE_STENTITY = 'UPDATE_STENTITY';
export const CLEAR_MULTI_ENTITY = 'CLEAR_MULTI_ENTITY';
export const GET_ALL_ENGAGEMENT_ENTITIES = 'GET_ALL_ENGAGEMENT_ENTITIES';
export const MAP_ENTITIES_TO_BUSINESS_UNITS = 'MAP_ENTITIES_TO_BUSINESS_UNITS';
export const UPDATE_ENTITY_DOCUMENT_RELATE = 'UPDATE_ENTITY_DOCUMENT_RELATE';
export const DELETE_ENTITY_DOCUMENT_RELATE = 'DELETE_ENTITY_DOCUMENT_RELATE';

//Entity Forms
export const CREATE_ENTITY_FORM = 'CREATE_ENTITY_FORM';

//toast
export const SET_TOASTER_VISIBILITY = 'SET_TOASTER_VISIBILITY';

//Section Compare
export const GET_COMPARE_BODIES_BY_SECTION_ID = 'GET_COMPARE_BODIES_BY_SECTION_ID';

//Relate Task
export const GET_DOCUMENT_AVAILABLE_TASKS = 'GET_DOCUMENT_AVAILABLE_TASKS';
export const GET_DOCUMENT_RELATED_TASKS = 'GET_DOCUMENT_RELATED_TASKS';
export const RELATE_TASK_TO_DOCUMENT = 'RELATE_TASK_TO_DOCUMENT';
export const UNRELATE_TASK_FROM_DOCUMENT = 'UNRELATE_TASK_FROM_DOCUMENT';

//Body Guidances
export const GET_BODY_GUIDANCES = 'GET_BODY_GUIDANCES';
export const RELATE_BODY_GUIDANCE_TO_TASK = 'RELATE_BODY_GUIDANCE_TO_TASK';

//Bulk Relate Task
export const CLEAR_UPLOAD_DOCUMENT_ID = 'CLEAR_UPLOAD_DOCUMENT_ID';
export const SAVE_UPLOAD_DOCUMENT_ID = 'SAVE_UPLOAD_DOCUMENT_ID';
export const SAVE_UPLOAD_DOCUMENTS = 'SAVE_UPLOAD_DOCUMENTS';
export const UPDATE_UPLOAD_DOCUMENT = 'UPDATE_UPLOAD_DOCUMENT';
export const CLEAR_UPLOAD_DOCUMENTS = 'CLEAR_UPLOAD_DOCUMENTS';
export const REMOVE_UPLOAD_DOCUMENT = 'REMOVE_UPLOAD_DOCUMENT';

// Mark Complete
export const MARK_COMPLETE_GET_LINKED_FORMS = 'MARK_COMPLETE_GET_LINKED_FORMS';
export const MARK_COMPLETE_GET_DOCUMENTS = 'MARK_COMPLETE_GET_DOCUMENTS';
export const MARK_COMPLETE_GET_DOCUMENT_BY_ID = 'MARK_COMPLETE_GET_DOCUMENT_BY_ID';
export const RESET_BULK_MARK_COMPLETE = 'RESET_BULK_MARK_COMPLETE';

// Create Form
export const GET_ALL_KNOWLEDGE_FORM = 'GET_ALL_KNOWLEDGE_FORM';
export const IMPORT_DOCUMENT = 'IMPORT_DOCUMENT';
export const CREATE_FORM_PROFILE = 'CREATE_FORM_PROFILE';
export const DOCSERVICE_DOCUMENT_PATCH = 'DOCSERVICE_DOCUMENT_PATCH';
export const UPDATE_CONTENT = 'UPDATE_CONTENT';
export const CREATE_TASK_DOCUMENTS = 'CREATE_TASK_DOCUMENTS';

//manage accounts
export const GET_MANAGE_ACCOUNTS = 'GET_MANAGE_ACCOUNTS';
export const DELETE_MANAGE_ACCOUNT = 'DELETE_MANAGE_ACCOUNT';
export const CREATE_MANAGE_ACCOUNT = 'CREATE_MANAGE_ACCOUNT';
export const UPDATE_MANAGE_ACCOUNT = 'UPDATE_MANAGE_ACCOUNT';
export const GET_MANAGE_ACCOUNT_BY_ID = 'GET_MANAGE_ACCOUNT_BY_ID';
export const CLEAN_MANAGE_ACCOUNT = 'CLEAN_MANAGE_ACCOUNT';

//flow chart
export const CREATE_FLOWCHART = 'CREATE_FLOWCHART';
export const GET_FLOWCHART = 'GET_FLOWCHART';
export const GET_FLOWCHARTS = 'GET_FLOWCHARTS';
export const CLEAR_FLOWCHART = 'CLEAR_FLOWCHART';
export const CREATE_FLOWCHART_NEW_STEP = 'CREATE_FLOWCHART_NEW_STEP';
export const SAVE_FLOWCHART_CONNECTION = 'SAVE_FLOWCHART_CONNECTION';
export const DELETE_FLOWCHART_CONNECTION = 'DELETE_FLOWCHART_CONNECTION';

//flowchart step
export const GET_FLOWCHART_STEP_BY_ID = 'GET_FLOWCHART_STEP_BY_ID';
export const EDIT_FLOWCHART_STEP = 'EDIT_FLOWCHART_STEP';
export const DELETE_FLOWCHART_STEP = 'DELETE_FLOWCHART_STEP';
export const RELATE_WCGW_TO_FLOWCHART_STEP = 'RELATE_WCGW_TO_FLOWCHART_STEP';
export const UNRELATE_WCGW_FROM_FLOWCHART_STEP = 'UNRELATE_WCGW_FROM_FLOWCHART_STEP';
export const RELATE_IT_APPLICATION_TO_FLOWCHART_STEP = 'RELATE_IT_APPLICATION_TO_FLOWCHART_STEP';
export const UNRELATE_IT_APPLICATION_FROM_FLOWCHART_STEP = 'UNRELATE_IT_APPLICATION_FROM_FLOWCHART_STEP';
export const UPDATE_STORE_RELATED_FLOWCHARTSTEPWCGW = 'UPDATE_STORE_RELATED_FLOWCHARTSTEPWCGW';
export const UPDATE_STORE_RELATED_FLOWCHARTSTEP_IT_APPLICATION_SO =
	'UPDATE_STORE_RELATED_FLOWCHARTSTEP_IT_APPLICATION_SO';
export const UPDATE_STORE_UNRELATED_IT_APPLICATION_FROM_FLOWCHARTSTEP_IT_APPLICATION_SO =
	'UPDATE_STORE_UNRELATED_IT_APPLICATION_FROM_FLOWCHARTSTEP_IT_APPLICATION_SO';
export const UPDATE_STORE_UNRELATED_WCGW_FROM_FLOWCHARTSTEPWCGW = 'UPDATE_STORE_UNRELATED_WCGW_FROM_FLOWCHARTSTEPWCGW';
export const SET_IS_FLOWCHART_STEP_EDIT_MODAL_OPEN = 'SET_IS_FLOWCHART_STEP_EDIT_MODAL_OPEN';
export const RELATE_CONTROL_TO_FLOWCHART_STEP = 'RELATE_CONTROL_TO_FLOWCHART_STEP';
export const UPDATE_STORE_RELATED_FLOWCHARTSTEP_CONTROL = 'UPDATE_STORE_RELATED_FLOWCHARTSTEP_CONTROL';
export const UNRELATE_CONTROL_FROM_FLOWCHART_STEP = 'UNRELATE_CONTROL_FROM_FLOWCHART_STEP';
export const UPDATE_STORE_UNRELATED_CONTROL_FROM_FLOWCHARTSTEP_CONTROL =
	'UPDATE_STORE_UNRELATED_CONTROL_FROM_FLOWCHARTSTEP_CONTROL';
export const CLEAR_FLOWCHART_STEP = 'CLEAR_FLOWCHART_STEP';
export const RELATE_DOCUMENT_TO_FLOWCHART_STEP = 'RELATE_DOCUMENT_TO_FLOWCHART_STEP';
export const UNRELATE_DOCUMENT_TO_FLOWCHART_STEP = 'UNRELATE_DOCUMENT_TO_FLOWCHART_STEP';

// Control Attributes
export const CREATE_CONTROL_ATTRIBUTES = 'CREATE_CONTROL_ATTRIBUTES';
export const GET_CONTROL_ATTRIBUTES = 'GET_CONTROL_ATTRIBUTES';
export const GET_CONTROL_ATTRIBUTE_BY_ID = 'GET_CONTROL_ATTRIBUTE_BY_ID';
export const UPDATE_CONTROL_ATTRIBUTES = 'UPDATE_CONTROL_ATTRIBUTES';
export const DELETE_CONTROL_ATTRIBUTES = 'DELETE_CONTROL_ATTRIBUTES';

// Entity Top Metadata
export const GET_TOP_ENTITY_METADATA = 'GET_TOP_ENTITY_METADATA';

export const RELATE_ESTIMATE_TO_RISK = 'RELATE_ESTIMATE_TO_RISK';
export const UNRELATE_ESTIMATE_TO_RISK = 'UNRELATE_ESTIMATE_TO_RISK';

//Project
export const GET_OVERSIGHT_PROJECTS_BY_ENGAGEMENT = 'GET_OVERSIGHT_PROJECTS_BY_ENGAGEMENT';
export const GET_OVERSIGHT_OTHER_PROJECTS_BY_ENGAGEMENT = 'GET_OVERSIGHT_OTHER_PROJECTS_BY_ENGAGEMENT';
export const CREATE_GROUP_OVERSIGHT_PROJECT = 'CREATE_GROUP_OVERSIGHT_PROJECT';

// EYQ actions
export const SET_AICHATBOT_INTEGRATION_PARAMETERS = 'SET_AICHATBOT_INTEGRATION_PARAMETERS';
export const GET_AICHATBOT_INTEGRATION_PARAMETERS = 'GET_AICHATBOT_INTEGRATION_PARAMETERS';
